import { computed, defineComponent, nextTick, PropType } from "vue";
import { OfferJson } from "../OrderForm";
import OfferBox from "./OfferBox";
import OfferUtils, { OfferCode, OfferTariff } from "../utils/OfferUtils";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export const OffersSlider = defineComponent({
    components: {
        OfferBox,
    },

    template: `
        <div ref="slider" class="Offers__slider swiper">
            <div :class="{ 'swiper-wrapper': inited }">
                <OfferBox
                    v-for="offer in offers"

                    class="swiper-slide"

                    :offer="offer"
                    :type="type ? type : 'featured'"
                    :code="code"

                    :label_select="label_select"

                    @click="$emit('offer:click', offer)"
                />
            </div>

            <div v-if="arrows" ref="prev" class="swiper-button-prev" @click1="swiper.slidePrev()">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="38" viewBox="0 0 22 38" fill="none">
                    <path d="M7.3226 17.7279L7.32325 17.7272L19.0241 6.0121C19.0243 6.01188 19.0245 6.01167 19.0247 6.01145C20.0539 4.98161 20.0536 3.3019 19.0241 2.27234C17.9943 1.24256 16.3141 1.24255 15.2843 2.27234L3.58284 13.9738C0.805718 16.7509 0.805719 21.2527 3.58284 24.0298L15.2843 35.7312L16.345 34.6706L15.2843 35.7312C15.8264 36.2733 16.5098 36.5 17.1614 36.5C17.8564 36.5 18.5062 36.2312 19.0036 35.7649L19.0213 35.7483L19.0384 35.7312C20.0682 34.7015 20.0682 33.0213 19.0384 31.9915L19.0377 31.9908L7.3226 20.29C6.61937 19.5868 6.61937 18.4311 7.3226 17.7279Z" fill="#9747FF" stroke="white" stroke-width="3"/>
                </svg>
            </div>

            <button v-if="arrows" ref="next" class="swiper-button-next" @click1="swiper.slideNext()">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="38" viewBox="0 0 22 38" fill="none">
                    <path d="M14.6774 17.7279L14.6767 17.7272L2.97593 6.0121C2.97571 6.01188 2.9755 6.01167 2.97528 6.01145C1.94615 4.98161 1.94636 3.3019 2.97593 2.27234C4.00571 1.24256 5.68591 1.24255 6.71569 2.27234L18.4172 13.9738C21.1943 16.7509 21.1943 21.2527 18.4172 24.0298L6.71569 35.7312L5.65503 34.6706L6.71569 35.7312C6.17363 36.2733 5.49023 36.5 4.83865 36.5C4.14363 36.5 3.49378 36.2312 2.99636 35.7649L2.97871 35.7483L2.96161 35.7312C1.93183 34.7015 1.93182 33.0213 2.96161 31.9915L2.96226 31.9908L14.6774 20.29C15.3806 19.5868 15.3806 18.4311 14.6774 17.7279Z" fill="#9747FF" stroke="white" stroke-width="3"/>
                </svg>
            </button>

            <div ref="pager" class="swiper-pagination"></div>
        </div>
    `,

    emits: [
        'offer:click',
    ],

    props: {
        offers: { type: Array, required: true },
        type: { type: String, default: null },
        code: { type: Object as PropType<OfferCode> },

        label_select: { type: String, default: 'Sprawdź ofertę' },

        initialslide: { type: Number, default: 0 },
        centered: { type: Number, default: 0 },
        arrows: { type: Boolean, default: false },

        maxwidth: { type: Number },
    },

    data() {
        return {
            inited: false,
            swiper: null,

            width: null,
        };
    },

    mounted() {
        $(window).on('resize', () => {
            this.width = window.innerWidth;
        });

        this.width = window.innerWidth;

        setInterval(() => {
            this.repos();
        }, 300);

        this.reinit();
    },

    watch: {
        offers() {
            this.reinit();
        },

        width() {
            this.reinit();
        },
    },

    methods: {
        reinit() {
            nextTick(() => {
                this.unswip();

                if (this.maxwidth == null || this.width <= this.maxwidth) {
                    nextTick(() => {
                        this.swip();
                    });
                }
            });
        },

        async swip() {
            await this.unswip();

            this.inited = true;

            return new Promise((res, err) => {
                nextTick(() => {
                    this.swiper = new Swiper(this.$refs.slider, {
                        modules: [Navigation, Pagination],

                        centeredSlides: this.centered == 1,
                        centerInsufficientSlides: this.centered == 2,

                        slidesPerView: 'auto',
                        initialSlide: this.initialslide,
                        spaceBetween: 24,

                        navigation: {
                            prevEl: this.$refs.prev,
                            nextEl: this.$refs.next,
                        },

                        pagination: {
                            el: this.$refs.pager,
                            type: 'bullets',
                            clickable: true,
                        },
                    });

                    nextTick(() => {
                        this.repos();

                        res(true);
                    });
                });
            });
        },

        async unswip() {
            return new Promise((res, err) => {
                if (this.swiper) {
                    this.swiper.destroy();
                    this.swiper = null;
                }

                nextTick(() => {
                    this.inited = false;

                    res(true);
                });
            });
        },

        async repos() {
            const $slider = $(this.$refs.slider);

            const $items = $('.OfferBox', $slider);

            const wx = $slider.width();
            let iw = 0;
            let maxh = 0;

            for (const item of $items) {
                const $item = $(item);

                const h = $item.innerHeight();

                if (h > maxh) {
                    maxh = h;
                }

                iw += $item.outerWidth();
            }

            for (const item of $items) {
                const $item = $(item);

                const w = $item.innerWidth();
                const h = $item.innerHeight();

                let padx = 0;
                const pady = maxh - h;

                // if (this.featured_center && wx > iw) {
                //     padx = (wx - iw) / 2;
                // }

                // console.log(padx, wx, iw);


                $item.css('transform', `translate(${padx}px, ${pady}px)`);

                const left = $item.offset().left;

                $item.toggleClass('OfferBox--outside', left + w > window.innerWidth);
            }
        },
    },
});

const OfferTariffHeader = defineComponent({
    template: `
        <h2 class="Offers__tariff">
            <i>
                <svg v-if="tariff == 'G11'" xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                    <g clip-path="url(#clip0_11677_49756)">
                        <path d="M23.873 0.306641C19.3664 0.306641 15.6997 3.97331 15.6997 8.47997C15.6997 12.9866 19.3664 16.6533 23.873 16.6533C28.3797 16.6533 32.0464 12.9866 32.0464 8.47997C32.0464 3.97331 28.3797 0.306641 23.873 0.306641ZM23.873 14.5333C20.5397 14.5333 17.833 11.8266 17.833 8.49331C17.833 5.15997 20.5397 2.45331 23.873 2.45331C27.2064 2.45331 29.913 5.15997 29.913 8.49331C29.913 11.8266 27.2064 14.5333 23.873 14.5333Z" fill="#005537"/>
                        <path d="M26.2466 6.1068L24.94 6.76014V4.21347C24.94 3.62681 24.46 3.1468 23.8733 3.1468C23.2866 3.1468 22.8066 3.62681 22.8066 4.21347V8.48014C22.8066 8.85347 22.9933 9.20014 23.3133 9.38681C23.4866 9.49347 23.6733 9.5468 23.8733 9.5468C24.0333 9.5468 24.1933 9.5068 24.3533 9.44014L27.1933 8.01347C27.7266 7.74681 27.94 7.1068 27.6733 6.5868C27.4066 6.0668 26.7666 5.84014 26.2466 6.1068Z" fill="#005537"/>
                        <path d="M2.91357 31.0532H9.43357C10.0202 31.0532 10.5002 30.5732 10.5002 29.9865C10.5002 29.3999 10.0202 28.9199 9.43357 28.9199H5.22023L9.27357 24.1732C10.7002 22.5065 10.5936 19.9999 9.0469 18.4532L8.9269 18.3332C7.2869 16.6932 4.6069 16.6932 2.9669 18.3332C2.19357 19.1065 1.75357 20.1332 1.74023 21.2265C1.74023 21.8132 2.19357 22.3065 2.78023 22.3199C3.3669 22.2932 3.86023 21.8665 3.87357 21.2799C3.87357 20.7465 4.10023 20.2399 4.4869 19.8532C5.30023 19.0399 6.62023 19.0399 7.43357 19.8532L7.55357 19.9732C8.31357 20.7332 8.3669 21.9732 7.66023 22.7999L2.10023 29.3065C1.83357 29.6265 1.7669 30.0665 1.94023 30.4532C2.11357 30.8265 2.4869 31.0665 2.91357 31.0665V31.0532Z" fill="#005537"/>
                        <path d="M17.1664 16.7734H16.3398C15.9798 16.7734 15.6464 16.9601 15.4464 17.2534L10.1531 25.3468C9.93976 25.6801 9.92642 26.0934 10.1131 26.4401C10.2998 26.7868 10.6598 27.0001 11.0464 27.0001H16.0998V29.9734C16.0998 30.5601 16.5798 31.0401 17.1664 31.0401C17.7531 31.0401 18.2331 30.5601 18.2331 29.9734V27.0001H19.1531C19.7398 27.0001 20.2198 26.5201 20.2198 25.9334C20.2198 25.3468 19.7398 24.8668 19.1531 24.8668H18.2331V17.8401C18.2331 17.2534 17.7531 16.7734 17.1664 16.7734ZM16.0998 24.8801H13.0198L16.0998 20.1734V24.8801Z" fill="#005537"/>
                        <path d="M23.073 20.8268C22.4863 20.8268 22.0063 21.3068 22.0063 21.8935V29.9868C22.0063 30.5735 22.4863 31.0535 23.073 31.0535C23.6597 31.0535 24.1397 30.5735 24.1397 29.9868V26.7735C24.1397 26.2002 24.6063 25.7202 25.1797 25.7202C25.753 25.7202 26.233 26.1868 26.233 26.7735V29.9868C26.233 30.5735 26.713 31.0535 27.2997 31.0535C27.8863 31.0535 28.3663 30.5735 28.3663 29.9868V26.7735C28.3663 25.0135 26.9397 23.6002 25.193 23.6002C24.8197 23.6002 24.473 23.6802 24.153 23.7868V21.9068C24.153 21.3202 23.673 20.8402 23.0863 20.8402L23.073 20.8268Z" fill="#005537"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_11677_49756">
                        <rect width="32" height="32" fill="white" transform="translate(0.5)"/>
                        </clipPath>
                    </defs>
                </svg>

                <svg v-if="tariff == 'G12'" xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                    <path d="M9.11324 26.84C9.60657 27.16 10.2732 27.0133 10.5799 26.5066C10.8866 26 10.7532 25.3466 10.2466 25.04C7.32657 23.1866 5.37991 20.2133 4.89991 16.8666C4.40657 13.4 5.44657 10.0266 7.60657 7.50663C7.29991 9.47996 7.56658 11.52 7.84657 13.7333C8.44657 18.36 12.0066 22.44 16.9132 24.1466C17.8599 24.48 18.8332 24.6933 19.8332 24.8C20.9399 24.92 22.0199 24.92 23.0866 24.8C20.7932 26.3733 17.9532 27.0933 15.1266 26.7733C14.8599 26.7466 14.5799 26.7066 14.3132 26.6533C13.7399 26.5466 13.1799 26.9333 13.0732 27.5066C12.9666 28.08 13.3532 28.64 13.9266 28.7466C14.2466 28.8 14.5532 28.8533 14.8866 28.8933C15.4066 28.9466 15.9399 28.9866 16.4599 28.9866C20.4466 28.9866 24.2732 27.28 26.9132 24.24C27.2199 23.88 27.2599 23.36 27.0066 22.96L26.6999 22.48C26.4332 22.0666 25.8999 21.8933 25.4332 22.0666C23.7399 22.6933 21.9399 22.8933 20.0866 22.6933C19.2466 22.6 18.4332 22.4133 17.6332 22.1333C13.4732 20.6933 10.4732 17.2933 9.97991 13.4666C9.48657 9.65329 9.27324 7.19996 10.9799 4.70663C11.2599 4.29329 11.2199 3.74663 10.8866 3.37329C10.5532 3.01329 10.0066 2.91996 9.56657 3.17329C4.64657 5.99996 1.99324 11.48 2.79324 17.16C3.35324 21.12 5.65991 24.6533 9.09991 26.84H9.11324Z" fill="#005537"/>
                    <path d="M22.0195 18.1067C26.5262 18.1067 30.1929 14.4401 30.1929 9.9334C30.1929 5.42674 26.5262 1.76007 22.0195 1.76007C17.5129 1.76007 13.8462 5.42674 13.8462 9.9334C13.8462 14.4401 17.5129 18.1067 22.0195 18.1067ZM22.0195 3.88007C25.3529 3.88007 28.0595 6.58674 28.0595 9.92007C28.0595 13.2534 25.3529 15.9601 22.0195 15.9601C18.6862 15.9601 15.9795 13.2534 15.9795 9.92007C15.9795 6.58674 18.6862 3.88007 22.0195 3.88007Z" fill="#005537"/>
                    <path d="M22.0198 10.9866C22.1798 10.9866 22.3531 10.9466 22.4998 10.8799L25.3398 9.45328C25.8731 9.18661 26.0865 8.54661 25.8198 8.02661C25.5531 7.50661 24.9131 7.29328 24.3931 7.54661L23.0865 8.19994V5.65328C23.0865 5.06661 22.6065 4.58661 22.0198 4.58661C21.4331 4.58661 20.9531 5.06661 20.9531 5.65328V9.91994C20.9531 10.2933 21.1398 10.6399 21.4598 10.8266C21.6331 10.9333 21.8198 10.9866 22.0198 10.9866Z" fill="#005537"/>
                </svg>

                <svg v-if="tariff == 'G12w'" xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                    <path d="M14.2866 14.5734H4.76663V12.9201C4.76663 12.1068 5.41997 11.4534 6.2333 11.4534H8.08663V11.9601C8.08663 12.5468 8.56663 13.0268 9.1533 13.0268C9.73997 13.0268 10.22 12.5468 10.22 11.9601V11.4534H12.6466C13.2333 11.4534 13.7133 10.9734 13.7133 10.3868C13.7133 9.80011 13.2333 9.32011 12.6466 9.32011H10.22V7.13344C10.22 6.54677 9.73997 6.06677 9.1533 6.06677C8.56663 6.06677 8.08663 6.54677 8.08663 7.13344V9.32011H6.2333C4.24663 9.32011 2.6333 10.9334 2.6333 12.9201V27.0668C2.6333 29.0534 4.24663 30.6668 6.2333 30.6668H23.94C25.9266 30.6668 27.54 29.0534 27.54 27.0668V19.5868C27.54 19.0001 27.06 18.5201 26.4733 18.5201C25.8866 18.5201 25.4066 19.0001 25.4066 19.5868V27.0668C25.4066 27.8801 24.7533 28.5334 23.94 28.5334H6.21997C5.41997 28.5334 4.7533 27.8801 4.7533 27.0668V16.7068H14.2866C14.8733 16.7068 15.3533 16.2268 15.3533 15.6401C15.3533 15.0534 14.8733 14.5734 14.2866 14.5734Z" fill="#005537"/>
                    <path d="M11.0333 20.88C11.4999 20.92 11.9399 20.5866 11.9933 20.1066C12.0466 19.6266 11.6999 19.2 11.2333 19.1466C9.79327 18.9866 7.95327 19.4533 7.31327 22.5733C7.09994 23.6133 7.20661 24.6533 7.59327 25.5066C8.01994 26.4533 8.76661 27.0933 9.65994 27.2666C9.84661 27.3066 10.0199 27.32 10.2066 27.32C10.7399 27.32 11.2733 27.16 11.7266 26.84C12.3266 26.4266 12.7399 25.8 12.8866 25.08C13.0333 24.36 12.8866 23.6266 12.4999 23C12.0999 22.3733 11.4866 21.9466 10.7666 21.8C10.2733 21.6933 9.76661 21.7466 9.29994 21.9066C9.73994 20.88 10.3933 20.7733 11.0466 20.84L11.0333 20.88ZM9.59327 23.7466C9.81994 23.5466 10.1266 23.4666 10.4199 23.52C10.6733 23.5733 10.8866 23.72 11.0333 23.9466C11.1799 24.1733 11.2333 24.4666 11.1799 24.7466C11.1266 25.0266 10.9666 25.2666 10.7399 25.4266C10.5133 25.5733 10.2599 25.6266 10.0066 25.5733C9.71327 25.5066 9.49994 25.3066 9.35327 25.0933C9.35327 25.0533 9.32661 25.0266 9.31327 24.9866C9.23327 24.7866 9.20661 24.56 9.24661 24.3466C9.29994 24.1066 9.41994 23.8933 9.60661 23.7333L9.59327 23.7466Z" fill="#005537"/>
                    <path d="M18.2068 27.0533C18.3268 27.1066 18.4601 27.1466 18.5935 27.1466C18.9135 27.1466 19.2201 26.9733 19.3668 26.6533L22.3668 20.5066C22.5001 20.24 22.4868 19.92 22.3268 19.6666C22.1668 19.4133 21.8868 19.2533 21.5935 19.2533H17.8335C17.3535 19.2533 16.9668 19.64 16.9668 20.12C16.9668 20.6 17.3535 20.9866 17.8335 20.9866H20.2068L17.8068 25.88C17.5935 26.3066 17.7801 26.8266 18.2068 27.04V27.0533Z" fill="#005537"/>
                    <path d="M15.1264 22.4532C14.6464 22.4532 14.2598 22.8399 14.2598 23.3199C14.2598 23.7999 14.6464 24.1866 15.1264 24.1866H16.5531C17.0331 24.1866 17.4198 23.7999 17.4198 23.3199C17.4198 22.8399 17.0331 22.4532 16.5531 22.4532H15.1264Z" fill="#005537"/>
                    <path d="M23.0732 1.34668C18.5666 1.34668 14.8999 5.01335 14.8999 9.52001C14.8999 14.0267 18.5666 17.6933 23.0732 17.6933C27.5799 17.6933 31.2466 14.0267 31.2466 9.52001C31.2466 5.01335 27.5799 1.34668 23.0732 1.34668ZM23.0732 15.56C19.7399 15.56 17.0332 12.8533 17.0332 9.52001C17.0332 6.18668 19.7399 3.48001 23.0732 3.48001C26.4066 3.48001 29.1132 6.18668 29.1132 9.52001C29.1132 12.8533 26.4066 15.56 23.0732 15.56Z" fill="#005537"/>
                    <path d="M25.4463 7.14652L24.1397 7.79986V5.25319C24.1397 4.66652 23.6597 4.18652 23.073 4.18652C22.4863 4.18652 22.0063 4.66652 22.0063 5.25319V9.51986C22.0063 9.89319 22.193 10.2399 22.513 10.4265C22.6863 10.5332 22.873 10.5865 23.073 10.5865C23.233 10.5865 23.393 10.5465 23.553 10.4799L26.393 9.05319C26.9263 8.78652 27.1397 8.14652 26.873 7.62652C26.6063 7.10652 25.9663 6.87986 25.4463 7.14652Z" fill="#005537"/>
                </svg>
            </i>

            <span>
                {{ label }} <b>{{ tariff }}</b>
            </span>
        </h2>
    `,

    props: {
        tariff: { type: String, require: true },
    },

    setup(props, ctx) {
        const label = computed(() => {
            switch (props.tariff) {
                case OfferTariff.G11:
                    return 'Taryfy Całodobowe';

                case OfferTariff.G12:
                    return 'Taryfy Nocne';

                case OfferTariff.G12w:
                    return 'Taryfy Weekendowe';
            }
        });

        return {
            label,
        }
    },
});

export default defineComponent({
    components: {
        OfferBox,
        OffersSlider,
        OfferTariffHeader,
    },

    template: `
        <div class="Offers">
            <div class="wrapper wrapper--full">
                <div v-if="visible_featured && featured?.length" class="Offers__featured">
                    <OfferTariffHeader
                        v-if="visible_groups"
                        :tariff="featured[0].tariff"
                    />

                    <OffersSlider
                        :offers="featured"
                        :code="code"

                        :label_select="label_select"

                        :centered="featured_centered"
                        :arrows="arrows"
                        :initialslide="featured_initialslide"

                        @offer:click="onOfferClick"
                    />
                </div>

                <div v-if="visible_rest && rest?.length" class="Offers__rest">
                    <template v-for="group in getByGroups(rest)">
                        <OfferTariffHeader
                            v-if="visible_groups"
                            :tariff="group.tariff"
                        />

                        <OffersSlider
                            :offers="group.offers"
                            :code="code"

                            :centered="featured_centered"
                            :arrows="arrows"

                            @offer:click="onOfferClick"
                        />
                    </template>
                </div>
            </div>
        </div>
    `,

    emits: [
        'offer:click',
    ],

    props: {
        offers: { type: Array as PropType<OfferJson[]>, required: true },
        code: { type: Object as PropType<OfferCode> },

        label_select: { type: String, default: 'Sprawdź ofertę' },

        allasfeatured: { type: Boolean, default: false },
        featured_centered: { type: Number, default: 2 },
        arrows: { type: Boolean, default: true },
        featured_initialslide: { type: Number, default: 0 },

        visible_groups: { type: Boolean, default: true },
        visible_featured: { type: Boolean, default: true },
        visible_rest: { type: Boolean, default: true },
    },

    setup(props, ctx) {
        const sortedoffers = computed(() => {
            return props.offers.sort((a, b) => {
                return a.price_warranty - b.price_warranty;
            });
        });

        const featured = computed(() => {
            if (props.allasfeatured) {
                return sortedoffers.value;
            } else {
                return sortedoffers.value.filter(v => v.tariff == OfferTariff.G11);
            }
        });

        const rest = computed(() => {
            if (props.allasfeatured) {
                return [];
            } else {
                return sortedoffers.value.filter(v => v.tariff != OfferTariff.G11);
            }
        });

        function getByGroups(list: OfferJson[]) {
            const result = [];

            if (list) {
                list.sort((a, b) => {
                    return a.tariff.localeCompare(b.tariff);
                });

                let offers = [];

                let prev = null;

                for (const offer of list) {
                    if (prev && prev.tariff != offer.tariff) {
                        result.push({
                            tariff: offers[0].tariff,
                            offers: offers,
                        });

                        offers = [];
                    }

                    offers.push(offer);

                    prev = offer;
                }

                if (offers.length) {
                    result.push({
                        tariff: offers[0].tariff,
                        offers: offers,
                    });
                }
            }

            return result;
        }

        function onOfferClick(offer: OfferJson) {
            ctx.emit('offer:click', offer);
        }

        return {
            featured,
            rest,

            getByGroups,
            onOfferClick,
        };
    },
});
